/* stylelint-disable */
@import '@helsenorge/designsystem-react/scss/_spacers.scss';
@import '@helsenorge/designsystem-react/scss/_breakpoints.scss';
@import '@helsenorge/designsystem-react/scss/_palette.scss';
@import '@helsenorge/designsystem-react/scss/_font-mixins.scss';

.temainngang {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  word-break: break-word;
  padding: getSpacer(2xs) getSpacer(m) getSpacer(2xs) getSpacer(2xs);

  @media (min-width: map-get($grid-breakpoints, md)) {
    padding: getSpacer(s) 0;
    flex-direction: column;
  }
  @media (min-width: map-get($grid-breakpoints, lg)) {
    padding: getSpacer(s) getSpacer(s) getSpacer(m) getSpacer(s);
  }

  &:focus-within {
    box-shadow: 0 0 0 0.1875rem $neutral600 inset;
  }

  &--neutral {
    background-color: $neutral50;
    &:hover {
      background-color: $neutral100;
    }
  }
  &--blueberry {
    background-color: $blueberry50;
    &:hover {
      background-color: $blueberry100;
    }
  }
  &--cherry {
    background-color: $cherry50;
    &:hover {
      background-color: $cherry100;
    }
  }

  &__image {
    max-width: 148px;
    max-height: 148px;
    @media (min-width: map-get($grid-breakpoints, md)) {
      align-self: center;
      max-height: 180px;
      max-width: 180px;
    }
    @media (min-width: map-get($grid-breakpoints, lg)) {
      width: 100%;
      max-width: 208px;
      max-height: 208px;
    }
  }

  &__content {
    padding: getSpacer(2xs) 0 getSpacer(2xs) getSpacer(2xs);
    align-self: center;
    @media (min-width: map-get($grid-breakpoints, md)) {
      padding: getSpacer(2xs) getSpacer(m) getSpacer(m) getSpacer(m);
    }
    @media (min-width: map-get($grid-breakpoints, lg)) {
      padding: getSpacer(2xs) getSpacer(2xs) 0 getSpacer(2xs);
    }
  }

  &__link {
    @include title3;
    display: block;
    color: $black;
    text-decoration: none;
    outline: 0;

    &--left {
      text-align: left;
    }

    &--centered {
      text-align: center;
    }

    // Triks for å få hele kortet til å trigge klikk på knappen
    &::after {
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &__ingress {
    font-size: 1rem;
    text-align: left;
    margin: 0;
    padding-top: getSpacer(2xs);
  }
}
